import React from 'react';

const LazyComponent = React.lazy(() =>
    import(/* webpackChunkName: "PdpRespDealerChat" */ './PdpRespDealerChat')
);

export const PdpRespDealerChatLazy = props => (
    <React.Suspense fallback="">
        <LazyComponent {...props} />
    </React.Suspense>
);
